import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Crown, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const PLAN_LABELS: Record<string, string> = {
  monthly: "Monthly",
  yearly: "Yearly",
  lifetime: "Lifetime",
};

export function PremiumSuccess() {
  const [params] = useSearchParams();
  const guildId = params.get("guild_id") || "";
  const plan = params.get("plan") || "";
  const pending = params.get("pending") === "1";

  return (
    <div className="max-w-lg mx-auto w-full space-y-6 py-10">
      <Card className="p-6 sm:p-8 text-center space-y-5 border-amber-500/30 bg-amber-500/5">
        <div className="flex justify-center">
          <div className="h-16 w-16 rounded-full bg-amber-500/20 flex items-center justify-center">
            <CheckCircle2 className="h-10 w-10 text-amber-400" />
          </div>
        </div>

        <div className="space-y-2">
          <Badge variant="premium" className="inline-flex">
            <Crown className="h-3 w-3" />
            Premium
          </Badge>
          <h1 className="text-2xl font-bold">
            {pending ? "Processing payment…" : "Payment successful!"}
          </h1>
          <p className="text-muted-foreground">
            {pending ? (
              <>
                PayPal is confirming your payment. Premium will activate in a
                few seconds. You can continue below.
              </>
            ) : (
              <>Thanks for your purchase! Premium is active for your server.</>
            )}
          </p>
          {plan && PLAN_LABELS[plan] ? (
            <p className="text-sm">
              Plan:{" "}
              <span className="font-semibold text-foreground">
                {PLAN_LABELS[plan]}
              </span>
            </p>
          ) : null}
        </div>

        <div className="grid gap-2 pt-2">
          {guildId ? (
            <Button asChild size="lg">
              <Link to={`/server/${guildId}`}>
                Open server panel
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
          ) : null}
          <Button asChild variant="outline">
            <Link to="/dashboard">Back to dashboard</Link>
          </Button>
        </div>
      </Card>
    </div>
  );
}
